import { Injectable } from '@angular/core';
import { Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { NumberingRepositoryBase } from '@skylab-shared/business';
export { NumberingRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(NumberingRepositoryBase)
export class NumberingRepository {
    public constructor(
        weaver: Weaver,
        queryBus: QueryBus,
        http: Http
    ) { }
}
